
import { domain } from '../config/AppConfigurator';

export const getAddessDetails = async (postcode, mpan, mprn, electricMeterSerialNumber, mpancore, xoserveAddressCode, mpancores, xoserveAddressCodes,accessToken, userAuthorization)=>{
    const response = await fetch(`${domain}/request/Address/recco/details`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
            'User-Authorization': `${userAuthorization}`
          },
        body: JSON.stringify({
            "postcode": postcode,
            "mpan": mpan,
            "mprn": mprn,
            "electricMeterSerialNumber": electricMeterSerialNumber,
            "mpancore": mpancore,
            "xoserveAddressCode": xoserveAddressCode,
            "mpancores": mpancores,
            "xoserveAddressCodes": xoserveAddressCodes
          })
    })
    return response.json();
}